import { render } from "./Platform.vue?vue&type=template&id=8b2cf156&scoped=true"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"

import "./Platform.vue?vue&type=style&index=0&id=8b2cf156&scoped=true&lang=css"
import "./Platform.vue?vue&type=style&index=1&id=8b2cf156&lang=css"

import exportComponent from "D:\\PRG\\gitEE\\wwj\\web\\htweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2cf156"]])

export default __exports__